import { defineStore } from 'pinia'
import { ref } from 'vue'

export type AdBlockerOfferErrorType = 'payment-error'

export const useAdBlockerOffer = defineStore('ad-blocker-offer', () => {
    const isOfferVisible = ref(false)
    const resolveFn = ref<((value: { completed: boolean }) => void) | null>(null)
    const rejectFn = ref<((value: { error: AdBlockerOfferErrorType }) => void) | null>(null)

    function showOffer() {
        isOfferVisible.value = true
        return new Promise<{ completed: boolean }>((resolve, reject) => {
            resolveFn.value = resolve
            rejectFn.value = reject
        })
    }

    function dismissOffer() {
        resolveFn.value?.({ completed: false })
        cleanup()
    }

    function completeOffer() {
        resolveFn.value?.({ completed: true })
        cleanup()
    }

    function rejectOffer(error: AdBlockerOfferErrorType) {
        rejectFn.value?.({ error })
        cleanup()
    }

    function cleanup() {
        resolveFn.value = null
        rejectFn.value = null
        isOfferVisible.value = false
    }

    return {
        isOfferVisible,
        showOffer,
        dismissOffer,
        rejectOffer,
        completeOffer,
    }
})
